document.addEventListener('DOMContentLoaded', function () {
  function translateFilterLabels() {
    document.querySelectorAll('.facets__label, .facet-checkbox__label, [class*="filter"] label, [class*="facet"] label').forEach(function (el) {
      if (el.dataset.translated) return; 

      var text = el.textContent.trim();
      if (text === 'true' || text === 'Yes') {
        el.textContent = window.Shopify.locale === 'he' ? 'כן' : 'Yes';
        el.dataset.translated = 'true';
      }
      if (text === 'false' || text === 'No') {
        el.textContent = window.Shopify.locale === 'he' ? 'לא' : 'Not on sale';
        el.dataset.translated = 'true'; 
      }
    });
  }

  translateFilterLabels();

  const observer = new MutationObserver(translateFilterLabels);
  observer.observe(document.body, { childList: true, subtree: true });
});
